let getAccessTokenSilently = (): Promise<string> | undefined => {
  console.warn('call to uninitialized get token function discarded')

  return undefined
}

export const auth0Token = {
  /**
   * @param options - Auth0 GetTokenSilentlyOptions
   * @returns promise of bearer token
   */
  getAccessTokenSilently: () => getAccessTokenSilently(),
  setAccessTokenSilentlyFunc: (func: any): void =>
    (getAccessTokenSilently = func)
}
